import React from 'react'
import useIsMobile from "../hooks/useIsMobile";

const Gastronomy = ({lang, translations, gastronomyIsActive}) => {
  const isDeviceMobile = useIsMobile();
  return (
    <main id={'aboutus'} className='background-black' >
      <div className="flex-column-start">
        <div>
          <h2 className="h2-title">{translations[lang].gastronomytitle}</h2>  
        </div>
          <div>
            <div className='flex-column'>
              <div className={isDeviceMobile?"flex-column width80" : 'flex-column width40 '}>
                <p className={isDeviceMobile?'p-text':"p-text"}>
                {translations[lang].textaboutus1}
                </p>
                <p className={isDeviceMobile?'p-text':"p-text"}>
                {translations[lang].textaboutus2}
                </p>
                <p className={isDeviceMobile?'p-text':"p-text"}>
                {translations[lang].textaboutus3}
                </p> 
                <p className={isDeviceMobile?'p-text':"p-text "}>
                {translations[lang].textaboutus4}
                </p> 
              </div>
              <div>
              <img src='img/facu-rodri.png' alt={translations[lang].facurodriimagealt} className='gastronomy-bg2'/>
              </div>
          </div>
        </div>
      </div>
  </main>
  )
}

export default Gastronomy